import {
  DOCUMENT_TYPE_LIST_FAIL,
  DOCUMENT_TYPE_LIST_REQUEST,
  DOCUMENT_TYPE_LIST_SUCCESS,
} from "../constants/documentTypeConstants";
import api from "../core/api";

export const listDocumentTypes = () => async (dispatch, getState) => {
  try {
    dispatch({ type: DOCUMENT_TYPE_LIST_REQUEST });

    const { data } = await api.get(`/accounts/documentType`);
    
    dispatch({
      type: DOCUMENT_TYPE_LIST_SUCCESS,
      payload: data[0],
    });
  } catch (error) {
    dispatch({
      type: DOCUMENT_TYPE_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
